var map = {
	"./american-truck-simulator.png": 8098,
	"./assetto-corsa.png": 6852,
	"./beamng-drive.png": 7907,
	"./city-car-driving.png": 7445,
	"./euro-truck-simulator-2.png": 2894
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90;